(function() {
  if (window.__mwCurrencyCodeLoaded) return;
  window.__mwCurrencyCodeLoaded = true;

  var DOLLAR_CODES = { CAD: true, USD: true, AUD: true, NZD: true, SGD: true, HKD: true };
  var PRICE_PATTERN = /(^|[^\w])\$(\s?[0-9]+(?:,[0-9]{3})*(?:\.[0-9]{2})?)(?![\d.,])(?!\s?(?:CAD|USD|AUD|NZD|SGD|HKD)\b)/g;

  function activeCurrencyCode() {
    var meta = document.querySelector('meta[name="cart-currency"]');
    var code = meta && meta.getAttribute('content');
    if (!code && window.Shopify && Shopify.currency) code = Shopify.currency.active;
    return String(code || '').toUpperCase();
  }

  function shouldSkipNode(node) {
    var parent = node && node.parentElement;
    if (!parent) return true;
    if (parent.closest && parent.closest('#gscdDrawer, .gscd')) return true;
    var tag = parent.tagName;
    return tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'TEXTAREA' || tag === 'OPTION';
  }

  function normalizeTextNode(node, code) {
    if (shouldSkipNode(node) || !node.nodeValue || node.nodeValue.indexOf('$') === -1) return;
    var next = node.nodeValue.replace(PRICE_PATTERN, function(match, prefix, amount) {
      return prefix + '$' + amount + ' ' + code;
    });
    if (next !== node.nodeValue) node.nodeValue = next;
  }

  function normalizeRoot(root) {
    var code = activeCurrencyCode();
    if (!DOLLAR_CODES[code] || !root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      normalizeTextNode(root, code);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE && root !== document.body) return;
    if (root.nodeType === Node.ELEMENT_NODE && root.closest && root.closest('#gscdDrawer, .gscd')) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) normalizeTextNode(node, code);
  }

  function start() {
    normalizeRoot(document.body);
    if (!window.MutationObserver || !document.body) return;

    var queued = false;
    var pending = [];
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'characterData') {
          pending.push(mutation.target);
          return;
        }
        mutation.addedNodes.forEach(function(node) {
          pending.push(node);
        });
      });
      if (queued) return;
      queued = true;
      requestAnimationFrame(function() {
        var nodes = pending.slice();
        pending = [];
        queued = false;
        nodes.forEach(normalizeRoot);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
